export enum sortDirection {
  asc = 1,
  desc = -1
}
